import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  GET_AUTH_USER,
  GET_AUTH_USER_SUCCESS,
  GET_AUTH_USER_FAIL,
  UPDATE_AUTH_USER,
  UPDATE_AUTH_USER_SUCCESS,
  UPDATE_AUTH_USER_FAIL,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  GET_AUTH_CUSTOMER,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const getAuthUsers = url => ({
  type: GET_AUTH_USER,
  payload: url,
})


export const getAuthCustomer = url => ({
  type: GET_AUTH_CUSTOMER,
  payload: url,
})



export const getAuthUsersSuccess = (auth, url) => ({
  type: GET_AUTH_USER_SUCCESS,
  payload: { auth, url },
})

export const getAuthUsersFail = error => ({
  type: GET_AUTH_USER_FAIL,
  payload: error,
})

export const updateAuthUser = (auth, _id) => ({
  type: UPDATE_AUTH_USER,
  payload: { auth, _id },
})


export const updateAuthUserSuccess = (auth) => ({
  type: UPDATE_AUTH_USER_SUCCESS,
  payload: auth,
})

export const updateAuthUserFail = error => ({
  type: UPDATE_AUTH_USER_FAIL,
  payload: error,
})


export const updateAuthUserPassword = (data) => ({
  type: UPDATE_PASSWORD_REQUEST,
  payload: data,
});

export const updateAuthUserPasswordSuccess = (data) => ({
  type: UPDATE_PASSWORD_SUCCESS,
  payload: data,
});

export const updateAuthUserPasswordFail = (error) => ({
  type: UPDATE_PASSWORD_FAIL,
  payload: error,
});


export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}


export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}
